import React from "react";

const Zip = props => (
  <svg viewBox="0 0 46 58" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M22.5 33c1.654 0 3-1.346 3-3v-3h-6v3c0 1.654 1.346 3 3 3zm-1-4h2a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2z" />
      <path d="M45.5 39V13.978c0-.766-.092-1.333-.55-1.792L33.313.55A1.891 1.891 0 0 0 31.985 0H2.963C1.777 0 .5.916.5 2.926V39h45zm-14-35.609c0-.458.553-.687.877-.363l10.095 10.095a.513.513 0 0 1-.363.877H31.5V3.391zM17.5 25h4v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2V9h2V7h2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h4v5c0 2.757-2.243 5-5 5s-5-2.243-5-5v-5zM31.251 45.858a1.657 1.657 0 0 0-.595-.492c-.255-.132-.593-.198-1.012-.198h-1.23v3.992h1.504c.2 0 .398-.034.595-.103.196-.068.376-.18.54-.335.164-.155.296-.371.396-.649.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567a1.648 1.648 0 0 0-.28-.616z" />
      <path d="M.5 41v15c0 1.009 1.22 2 2.463 2h40.074c1.243 0 2.463-.991 2.463-2V41H.5zm19.766 4.25l-4.799 7.205-.273.219h5.072V54h-6.699v-1.326l4.799-7.205.287-.219h-5.086v-1.326h6.699v1.326zM24.271 54h-1.668V43.924h1.668V54zm8.655-5.571a2.9 2.9 0 0 1-.725 1.046c-.31.282-.684.501-1.121.656a4.314 4.314 0 0 1-1.449.232h-1.217V54h-1.641V43.924h2.898c.428 0 .852.068 1.271.205.419.137.795.342 1.128.615.333.273.602.604.807.991.205.387.308.822.308 1.306.001.511-.086.973-.259 1.388z" />
    </g>
  </svg>
);

export default Zip;




// WEBPACK FOOTER //
// src/resources/svg/FileZIP.js